module.exports = new __parcel__URL__("cart.4579454e.svg").toString();